import { render, staticRenderFns } from "./OnboardingBirthdayForm.vue?vue&type=template&id=1b819d22"
import script from "./OnboardingBirthdayForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./OnboardingBirthdayForm.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports